"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCancel(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "7 -4 10 24" }, props),
        React.createElement("path", { d: "M7.96 11.03L10.99 8 7.96 4.97l1.01-1.01L12 6.99l3.03-3.03 1.01 1.01L13.01 8l3.03 3.03-1.01 1.01L12 9.01l-3.03 3.03z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Cancel')(SvgCancel);
//# sourceMappingURL=Cancel.js.map